(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeWellnessStatusComponent', psychIntakeWellnessStatusComponent);

    psychIntakeWellnessStatusComponent.$inject = [];

    function psychIntakeWellnessStatusComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeWellnessStatusController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/wellness-status.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeWellnessStatusController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeWellnessStatusController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();

        vm.disabledCheck = function(item) {
            if ($scope.vm.workflow.answer && $scope.vm.workflow.answer.stressorsSelected) {
                var selected = $scope.vm.workflow.answer.stressorsSelected;
	            if (item === 'NONE') {
	                var symptoms = ['RELATIONSHIP_PROBLEMS', 'FINANCIAL_PROBLEMS', 'HOUSING_PROBLEMS', 'DEATH_OF_LOVED_ONE', 'SERIOUS_FAMILY_ILLNESS', 'JOB_ISSUES'];
	                return symptoms.some(function(symptom) {
	                    return selected[symptom];
	                });
	            } else {
	                return selected['NONE'];
	            }
            } else {
            	return false;
            }
        }
    }
})();
